import { render } from "./ManagerReportResult.vue?vue&type=template&id=6ce4cbde&scoped=true"
import script from "./ManagerReportResult.vue?vue&type=script&lang=js"
export * from "./ManagerReportResult.vue?vue&type=script&lang=js"

import "./ManagerReportResult.vue?vue&type=style&index=0&id=6ce4cbde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce4cbde"]])

export default __exports__